import GenericLayout from 'components/GenericLayout'
import { CollectiveDemo } from 'components/Collectives/CollectiveDemo/CollectiveDemo'
import { CollectiveProvider } from 'context/CollectiveContext'
import { CollectiveDemoProvider } from 'context/CollectiveDemoContext'
import { NextSeo } from 'next-seo'

const collectiveDemoID = '4diA5edOyJ'

const metaImage =
  'https://i.upstreamapp.com/ogImages/collectives/demo-open-graph.png'

const metaUrl = 'https://upstreamapp.com/collectives'

function CreateCollectiveScreen() {
  return (
    <>
      <NextSeo
        openGraph={{
          url: metaUrl,
          images: [
            {
              url: metaImage,
              width: 1200,
              height: 630
            }
          ]
        }}
        twitter={{
          cardType: 'summary_large_image'
        }}
        additionalMetaTags={[
          {
            name: 'twitter:image',
            content: metaImage
          },
          {
            name: 'twitter:image:alt',
            content: 'DAOs Demo Flyer'
          }
        ]}
      />

      <GenericLayout bgColor="bg-white" effectiveNav fullWidth>
        <CollectiveDemoProvider collectiveDemoId={collectiveDemoID}>
          <CollectiveProvider demoMode collectiveId={collectiveDemoID}>
            <CollectiveDemo />
          </CollectiveProvider>
        </CollectiveDemoProvider>
      </GenericLayout>
    </>
  )
}

export default CreateCollectiveScreen
